import React, { createContext, useReducer } from 'react';
import { CarouselActionType, videoCarouselReducer, } from './videoCarouselReducer';
export const VideoCarouselContext = createContext({});
export const VideoCarouselProvider = ({ children, }) => {
    const initialState = {
        carouselPlay: true,
        isMuted: true,
    };
    const [{ isMuted, carouselPlay }, dispatch] = useReducer(videoCarouselReducer, initialState);
    return (React.createElement(VideoCarouselContext.Provider, { value: {
            isCarouselMuted: isMuted,
            toggleCarouselMute: () => dispatch({ type: CarouselActionType.TOGGLE_MUTE }),
            carouselPlay: carouselPlay,
            toggleCarouselPlay: () => dispatch({ type: CarouselActionType.TOGGLE_PLAY }),
        } }, children));
};
//# sourceMappingURL=VideoCarouselProvider.js.map